import { MINI_GAME_ORDER_DIRECTION_LABELS } from "@gameComponents/MiniGame/constants";

export function miniGameOrderDirection(short: boolean): string {
  return short
    ? MINI_GAME_ORDER_DIRECTION_LABELS.SHORT
    : MINI_GAME_ORDER_DIRECTION_LABELS.LONG;
}
